<script>
import useSharedSelectData from "@/use/SharedSelectData";
import {ref, watch} from "vue";

export default {
    props: {
        value: Object,
        vacation: Boolean,
        hideDate: Boolean,
    },
    setup(props, {emit}) {
        const {workerPhases, validationWorkFlowStatus} = useSharedSelectData();
        const panelModel = ref(0);
        
        const filter = ref({});
        
        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});
        
        
        return {
            filter,
            workerPhases,
            validationWorkFlowStatus,
            panelModel
        }
    },
};
</script>

<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong v-if="vacation">
                        {{ $t("module.vacation") }}
                    </strong>
                    <strong v-else>
                        {{ $t("module.absence_request") }}
                    </strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                    v-model="filter.workerId"
                                    :label="$t('module.worker')"
                                ></str-worker-autocomplete>
                            </v-col>
                            <v-col cols="12" v-if="!vacation">
                                <str-absence-reason-autocomplete
                                    v-model="filter.reasons"
                                    multiple
                                    :label="$t('module.absence_reason')"
                                ></str-absence-reason-autocomplete>
                            </v-col>
                            <v-col cols="12" v-if="!hideDate">
                                <w-date-picker
                                    v-model="filter.start"
                                    :label="$t('absence_request.start_date')"
                                />
                            </v-col>
                            <v-col cols="12" v-if="!hideDate">
                                <w-date-picker
                                    v-model="filter.end"
                                    :label="$t('absence_request.end_date')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('module.worker') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <organizational-chart-select
                                    v-model="filter.organizationalchartIds"
                                    :label="$t('module.organizational_chart')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-occupation-autocomplete
                                    v-model="filter.occupationId"
                                    :label="$t('module.occupation')"
                                />
                            </v-col>
                            
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.workplaceId"
                                    type="WORKER_WORKPLACE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.companyId"
                                    type="WORKER_COMPANY"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.stateId"
                                    type="WORKER_STATE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.phase"
                                    :items="workerPhases"
                                    :label="$t('worker.status')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('common.validation') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.validationStatus"
                                    :items="validationWorkFlowStatus"
                                    :label="$t('common.state')"
                                    multiple
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-step-select
                                    v-model="filter.lastState"
                                    :label="$t('common.validation')"
                                    module="TRAINING_REQUEST"
                                    by-name
                                ></str-step-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        
        <input type="hidden"/>
    </div>
</template>